import { useTranslation } from 'react-i18next';

export default function WhatIsSection() {
  const { t } = useTranslation();

  const steps = [
    { icon: 'ri-search-line', key: 'step_find', descKey: 'step_find_desc' },
    { icon: 'ri-file-list-3-line', key: 'step_research', descKey: 'step_research_desc' },
    { icon: 'ri-shopping-bag-line', key: 'step_buy', descKey: 'step_buy_desc' },
  ];

  return (
    <section id="whatis" className="w-full bg-background-50 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-5 font-heading">
                {t('whatis_title')}
              </h2>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
                {t('whatis_desc')}
              </p>
              <div className="space-y-4">
                <p className="text-base font-semibold text-foreground-950">
                  {t('hero_support_title')}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t('hero_support_desc')}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              {steps.map((step, idx) => (
                <div
                  key={step.key}
                  className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center font-bold text-sm">
                    {idx + 1}
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <i className={`${step.icon} text-primary-500`} />
                      <h3 className="font-semibold text-foreground-950">
                        {t(step.key)}
                      </h3>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {t(step.descKey)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}